import { useCoreDispatch, useCoreSelector } from "../../redux/config.js";
import { selectTransient } from "../../redux/transient/selectors.js";
import { updateTransient } from "../../redux/transient/thunks/update-transient.js";
//#region src/presentation/hooks/use-transient.ts
var useTransient = ({ key }) => {
	const dispatch = useCoreDispatch();
	const transient = useCoreSelector(selectTransient(key));
	const setTransient = async (value) => {
		await dispatch(updateTransient({ transient: {
			key,
			value
		} }));
	};
	return [transient, setTransient];
};
//#endregion
export { useTransient };

//# sourceMappingURL=use-transient.js.map